export {
  default 
} from "./icon";
